// extracted by mini-css-extract-plugin
export default {"number":"IconNumber_number__5aQ1U"};